var buildDistanceInWordsLocale = require('./build_distance_in_words_locale/index.js')
var buildFormatLocale = require('./build_format_locale/index.js')

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fns/locale/en/index.js
// module id = 788
// module chunks = 6 8 32 38 42 43 53 54 55 57 58 59 60 61 62 63 64 65 66 67 68 69 72 73 75 78 79 81 85